import { useProjectActions } from "@contexts/projects";
import { formatNumberToCurrency } from "@utils/formatNumber";
import { useEffect, useState } from "react"
import Select from 'react-select';

const MultipleAdvanceForm = ({ months, item }) => {
  const [monthsToAdvance, setMonthsToAdvance] = useState([])
  const { updateAdvancement } = useProjectActions()
  const [sameMonth, setSameMonth] = useState(true)
  const [direction, setDirection] = useState('')
  const [monthsAmount, setMonthsAmount] = useState(0)
  const [newData, setNewData] = useState({
    max: 0,
    value: '',
    description: '',
    newMonth: ''
  })
  const [max, setMax] = useState(0)
  const groupedMonths = months.map(i => ({ month: `${String(i.month).padStart(2, '0')}/${i.year}`, value: i.value }))

  const handleFilter = (e) => {
    setMonthsToAdvance(() => e.map(i => i.value))
    const max = groupedMonths
      .filter(i => e.map(i => i.value).includes(i.month))
      .reduce((acc, curr) => acc + curr.value, 0);
    setMax(() => max)
  }

  useEffect(() => {
    const values = months.map(i => i.value)
    const smallestValue = Math.min(...values);
    setNewData(prevData => ({ ...prevData, max: smallestValue }));
  }, [])

  const formatCurrency = (value) => {
    const cleanedValue = value.replace(/\D/g, "");
    const numericValue = parseFloat(cleanedValue) / 100;
    if (numericValue > max) {
      return max.toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
    }
    return numericValue.toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
    });
  };

  const handleInputChange = (e) => {
    let inputValue = e.target.value;
    inputValue = inputValue.replace(/\D/g, "");
    if (inputValue.length === 0) {
      setNewData(prev => ({ ...prev, value: "" }));
    } else {
      setNewData(prev => ({ ...prev, value: formatCurrency(inputValue) }));
    }
  };

  const checkDisabled = () => {
    if (sameMonth) {
      return (newData.value === '' || monthsToAdvance.length === 0 || newData.newMonth)
    } else {
      return (monthsToAdvance.length === 0 || monthsAmount === 0 || direction === '')
    }

  }

  const handleToChange = (e) => {
    const { value } = e.target
    setNewData(prev => ({ ...prev, to: `${value.slice(5, 7)}/${value.slice(0, 4)}` }))
  }

  const handleDescChange = (e) => {
    setNewData(prev => ({ ...prev, description: e.target.value }))
  }

  const handleSend = async () => {
    let toRemove = 0
    if (sameMonth) {
      const cleanedString = newData.value
        .replace(/[R$.\s]/g, "")
        .replace(",", ".");
      const numericValue = parseFloat(cleanedString);
      toRemove = numericValue
    }

    for (const i of monthsToAdvance) {
      if (sameMonth) {
        if (toRemove === 0) return
        let val
        const available = groupedMonths.filter(j => j.month === i)[0].value
        if (available <= toRemove) {
          val = available
          toRemove -= available
        } else {
          val = toRemove
          toRemove = 0
        }
        await updateAdvancement({
          operation: 'create',
          name: item.description,
          value: val,
          description: newData.description,
          to: newData.to,
          from: i,
          wbs: item.wbs_code_id,
        })
      } else {
        const [month, year] = i.split('/').map(Number);
        let newMonth = month + (direction === 'front' ? parseInt(monthsAmount) : -parseInt(monthsAmount));
        let newYear = year;
        while (newMonth > 12) {
          newMonth -= 12;
          newYear += 1;
        }
        while (newMonth < 1) {
          newMonth += 12;
          newYear -= 1;
        }
        const available = groupedMonths.filter(j => j.month === i)[0].value
        const formattedNewMonth = `${String(newMonth).padStart(2, '0')}/${newYear}`;
        await updateAdvancement({
          operation: 'create',
          name: item.description,
          value: available,
          description: newData.description,
          to: formattedNewMonth,
          from: i,
          wbs: item.wbs_code_id,
        })
      }
    }
  }

  return <div className="multiple-advancement-container">
    <p>Selecione os mês que deseja retirar o valor</p>
    <Select
      isMulti
      isClearable={false}
      name="creditors"
      options={groupedMonths.map(i => ({ value: i.month, label: i.month }))}
      onChange={handleFilter}
      className="basic-multi-select full-width"
      classNamePrefix="multipleMonths"
      placeholder='Escolher meses'
    />

    <div className="advancement-type-container margin-top-16">
      <h2 className={sameMonth && 'active'} onClick={() => setSameMonth(true)}>Todos para o mesmo mês</h2>
      <h2 className={!sameMonth && 'active'} onClick={() => setSameMonth(false)}>Mover cada um em X meses</h2>
    </div>

    {sameMonth && <><div className="advancement-form-container">
      <div>
        <p>Selecione o valor total que deseja mover:</p>
        <input
          className="resource-search"
          type="text"
          value={newData.value}
          placeholder={`Máximo: ${formatNumberToCurrency(max)}`}
          onChange={handleInputChange}
        />
      </div>
      <div>
        <p>Selecione o mês de destino:</p>
        <input className="resource-search" type='month' onChange={handleToChange} />
      </div>
      <div>
        <p>Descrição do ajuste (Opcional): </p>
        <input className="resource-search" type='text' onChange={handleDescChange} />
      </div>
    </div>
      <div className="flex direction-column justify-content-end">
        <button className={`button button-${checkDisabled() ? 'grey' : 'accent'} margin-bottom-16 margin-top-8`} disabled={checkDisabled()} onClick={handleSend}>Enviar</button>
      </div>
    </>
    }

    {!sameMonth && <><div className="advancement-form-container">
      {/* <div>
        <p>Selecione o valor que deseja adiantar:</p>
        <input
          type="text"
          value={newData.value}
          onChange={handleInputChange}
        />
      </div> */}
      <div>
        <p>Mover para:</p>
        <select defaultValue='' onChange={(e) => setDirection(e.target.value)}>
          <option value='' disabled>Selecione</option>
          <option value='front'>Meses à frente</option>
          <option value='back'>Meses atrás</option>
        </select>
      </div>
      <div>
        <p>Quantidade de meses: </p>
        <input type='number' onChange={(e) => setMonthsAmount(e.target.value)} value={monthsAmount} />
      </div>
      <div>
        <p>Descrição do ajuste (Opcional): </p>
        <input type='text' onChange={handleDescChange} />
      </div>
    </div>
      <div className="flex direction-column justify-content-end">
        <button className={`button button-${checkDisabled() ? 'grey' : 'accent'} margin-bottom-16 margin-top-8`} disabled={checkDisabled()} onClick={handleSend}>Enviar</button>
      </div>
    </>
    }

  </div>

}

export default MultipleAdvanceForm
